import classnames from 'classnames/bind';
import { Menu } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthentication } from 'hooks/api/useAuthentication';

import { Icon } from 'components/Icon/IconDeprecated';

import styles from './NavUserMenu.module.scss';

const c = classnames.bind(styles);

export function NavUserMenu() {
  const navigate = useNavigate();
  const { accessTokens } = useAPI();
  const { user, logout } = useAuthentication();

  if (!user) {
    return null;
  }

  const { name, email } = user;

  function handleLogoutClick() {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('mqtt-token')) {
        try {
          const tokenID = JSON.parse(localStorage[key]).id;
          accessTokens.delete(tokenID);
        } catch {
          //
        } finally {
          localStorage.removeItem(key);
        }
      }
    });
    localStorage.removeItem('console.token');

    logout();
  }

  function handleManageAccountClick() {
    navigate('settings/account');
  }

  return (
    <Menu>
      <Menu.Target>
        <button className={c('button')}>
          <Icon name="account" size="small" />
          <span>{name || email}</span>
        </button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          onClick={handleManageAccountClick}
          leftSection={<Icon name="settings" />}
        >
          Manage account
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          onClick={handleLogoutClick}
          leftSection={<Icon name="logout" />}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
